/**
 * Gallery layout / scroll / grid / media-item Tailwind tokens.
 * Field look comes from formShell; body copy uses typeShell.
 */

import { typeShell } from "./typeShell";

export const galleryShell = {
    root: "flex min-h-0 flex-1 flex-col",
    controls:
        "mb-2 flex shrink-0 flex-col flex-wrap items-start gap-3 border-0 border-b border-solid border-border p-0 pb-3 bp-lg:flex-row bp-lg:gap-4",
    icon: "material-icons mr-1.5 shrink-0 align-middle text-icon-control text-text-primary",
    section:
        "flex w-full min-w-0 flex-1 flex-col gap-1.5 bp-lg:w-auto bp-lg:min-w-0",
    searchSection:
        "flex w-full min-w-[clamp(12rem,30vw,20rem)] flex-[2_1_auto] flex-col gap-1.5 bp-lg:w-auto bp-lg:min-w-0",
    /* container-type:size → child max-h-[50cqh] resolves against this pane */
    scrollable:
        "min-h-0 flex-1 overflow-y-auto [container-type:size] [scrollbar-color:var(--border)_transparent] [scrollbar-gutter:stable] [scrollbar-width:thin] [&::-webkit-scrollbar]:w-[clamp(0.25rem,1vw,0.5rem)] [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb]:bg-border [&::-webkit-scrollbar-thumb:hover]:bg-accent",

    grid: "grid grid-cols-[repeat(auto-fill,minmax(6rem,1fr))] content-start gap-2 rounded-lg bg-surface p-1 bp-lg:grid-cols-[repeat(auto-fill,minmax(14rem,1fr))] bp-lg:gap-3 bp-lg:p-2 bp-xl:gap-3 bp-xl:p-2 bp-2xl:grid-cols-5 bp-2xl:gap-4 bp-2xl:p-2",
    gridEmpty:
        `flex h-full min-h-0 items-center justify-center p-6 text-center bp-lg:p-12 bp-xl:p-14 bp-2xl:p-16 ${typeShell.emptyPanel}`,

    /* ステージ内いっぱいに張り、メディアは object-contain で収める */
    item: "absolute inset-4 flex items-center justify-center",
    media: "h-full w-full object-contain",
    mediaAudio: "w-full max-w-full",
    deleteButton:
        "!absolute !right-0 !top-0 z-10 !flex !h-7 !w-7 !min-h-0 !min-w-0 !items-center !justify-center !rounded-full !border-none !bg-button-danger !p-0 !text-text-inverse !opacity-100 shadow-none transition-all duration-200 ease-in-out hover:!scale-110 hover:!bg-button-danger-hover active:!scale-100 active:!bg-ui-muted bp-lg:!h-10 bp-lg:!w-10",
    mediaError:
        `flex min-h-32 flex-col items-center justify-center p-4 text-center ${typeShell.hint} bp-lg:min-h-48 bp-lg:p-6 bp-xl:p-7 bp-2xl:min-h-[15rem] bp-2xl:p-8`,

    /* メディア実寸に依らずパネル寸法を固定（Modal className 用） */
    modalPanel:
        "!h-[min(80vh,36rem)] !w-full !max-w-full bp-md:!max-w-3xl bp-lg:!max-w-4xl",
    modalBody: "box-border flex min-h-0 flex-1 flex-col overflow-hidden",
    modalStage: "relative box-border min-h-0 flex-1 overflow-hidden",
    /* 作成者・説明は常に枠を確保（空でも高さを維持）。値は surface-muted の box */
    modalMeta:
        "box-border flex w-full shrink-0 flex-col gap-2 border-0 border-t border-solid border-border px-4 py-2.5 text-left",
    modalMetaRow: "flex min-w-0 flex-col gap-1",
    modalMetaLabel: `shrink-0 ${typeShell.hint}`,
    modalMetaValue:
        `box-border min-h-8 min-w-0 w-full break-words rounded-md border border-solid border-border-subtle bg-surface-muted px-2.5 py-1.5 ${typeShell.caption}`,
    modalMetaValueMuted:
        `box-border min-h-8 min-w-0 w-full break-words rounded-md border border-solid border-border-subtle bg-surface-muted px-2.5 py-1.5 ${typeShell.captionMuted}`,
    modalMetaDesc:
        "box-border max-h-16 min-h-10 overflow-y-auto whitespace-pre-wrap [overflow-wrap:anywhere]",
};
